import angular from 'angular';

import { AlertingService } from './alerting.services.js';
import { AngularMigrationHelperFactory } from './angularMigrationHelper.service.ts';
import { AppService } from './app.services.js';
import { AssertService } from './assert.services.js';
import { AsyncRequestService } from './async-request.services.js';
import { LocalStorageService } from './localStorage.services.js';
import { MediasService } from './medias.services.js';
import { ScrollService } from './scroll.service';
import { XHRStatsService } from './xhr-stats.services.js';

angular
  .module('app.services', ['cgNotify'])
  .factory('MediasFactory', MediasService.MediasFactory)
  .factory('AppFactory', AppService.AppFactory)
  .factory('LocalStorageFactory', LocalStorageService.LocalStorageFactory)
  .factory('Assert', AssertService.AssertFactory)
  .factory('XHRStatsFactory', XHRStatsService.XHRStatsFactory)
  .factory('AsyncRequestFactory', AsyncRequestService.AsyncRequestFactory)
  .factory('AlertingFactory', AlertingService.AlertingFactory)
  .factory('ScrollFactory', ScrollService.ScrollFactory)
  .factory('AngularMigrationHelperFactory', AngularMigrationHelperFactory)
  ;
